export enum OrderStep {
  TRIP_INFO = 0,
  CREATE_TRIP = 1,
  PAYEMNT = 2,
  PAYMENT_SUCCESS = 3,
  PAYMENT_FAILED = 4,
}
